import { z } from "zod";

// Playground TOV reuse surface: list the real clients whose active voice can be
// imported into a workspace, and the request to import one. The import response
// reuses TovVersionResponse (the freshly activated version), so it is not
// redefined here — routes import it from client-tov/version.responses.

// Rendered from the public client_tov_profiles ⋈ clients join alone — no
// per-Client schema access. The active version's label lives in the private
// schema and is deliberately not surfaced here; the profile name identifies the
// voice in the picker.
export const ImportableVoiceSchema = z.object({
  clientId: z.uuid(),
  clientName: z.string(),
  profileName: z.string(),
});
export type ImportableVoice = z.infer<typeof ImportableVoiceSchema>;

export const ImportableVoiceListResponseSchema = z.object({
  voices: z.array(ImportableVoiceSchema),
});
export type ImportableVoiceListResponse = z.infer<
  typeof ImportableVoiceListResponseSchema
>;

export const PlaygroundVoiceImportRequestSchema = z.object({
  sourceClientId: z.uuid(),
});
export type PlaygroundVoiceImportRequest = z.infer<
  typeof PlaygroundVoiceImportRequestSchema
>;
